module.exports = __webpack_public_path__ + "static/media/compass.4c010959.png";